import _ from 'lodash'

const getFluidImg = function getFluidImg(image) {
  return _.get(image, ['localFile', 'childImageSharp', 'fluid'], null)
}

export default getFluidImg
